import React, { useEffect } from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import '@/App.css';
import Home from '@/pages/Home';
import TrademarkRegistration from '@/pages/services/TrademarkRegistration';
import CopyrightRegistration from '@/pages/services/CopyrightRegistration';
import CompanyFormation from '@/pages/services/CompanyFormation';
import TrademarkSearch from '@/pages/services/TrademarkSearch';
import AmazonBrandRegistry from '@/pages/services/AmazonBrandRegistry';
import About from '@/pages/About';
import Contact from '@/pages/Contact';
import PrivacyPolicy from '@/pages/PrivacyPolicy';
import TermsOfService from '@/pages/TermsOfService';
import LandingPage from '@/pages/LandingPage';
import { Toaster } from '@/components/ui/sonner';

// Trademark Services
import RegisterTrademark from '@/pages/services/RegisterTrademark';
import ClearanceSearch from '@/pages/services/ClearanceSearch';
import TrademarkTransfers from '@/pages/services/TrademarkTransfers';
import StatementsOfUse from '@/pages/services/StatementsOfUse';
import TrademarkOfficeActions from '@/pages/services/TrademarkOfficeActions';
import TrademarkMonitoring from '@/pages/services/TrademarkMonitoring';
import TTABPetition from '@/pages/services/TTABPetition';

// Company Formation Services
import LLCFormation from '@/pages/services/LLCFormation';
import CCorporation from '@/pages/services/CCorporation';
import SCorporation from '@/pages/services/SCorporation';
import NonProfit from '@/pages/services/NonProfit';

// Copyright Services
import RegisterCopyright from '@/pages/services/RegisterCopyright';
import CopyrightEnforcement from '@/pages/services/CopyrightEnforcement';
import CopyrightTransfers from '@/pages/services/CopyrightTransfers';
import CopyrightLegalRepresentation from '@/pages/services/CopyrightLegalRepresentation';
import CopyrightPortfolio from '@/pages/services/CopyrightPortfolio';
import DMCACompliance from '@/pages/services/DMCACompliance';

// Patent Services
import PatentSearch from '@/pages/services/PatentSearch';
import PatentOfficeActions from '@/pages/services/PatentOfficeActions';
import PatentApplication from '@/pages/services/PatentApplication';
import PatentLegalRepresentation from '@/pages/services/PatentLegalRepresentation';

// Legal Services
import BusinessImmigration from '@/pages/services/BusinessImmigration';
import DueDiligence from '@/pages/services/DueDiligence';
import ITCommercialLaw from '@/pages/services/ITCommercialLaw';
import PartnershipsLLP from '@/pages/services/PartnershipsLLP';
import DataProtection from '@/pages/services/DataProtection';

// Additional Corporate Services
import Bookkeeping from '@/pages/services/Bookkeeping';
import BusinessFormation from '@/pages/services/BusinessFormation';
import CertificateGoodStanding from '@/pages/services/CertificateGoodStanding';
import CompanyDissolution from '@/pages/services/CompanyDissolution';
import CompanyNameChange from '@/pages/services/CompanyNameChange';
import CompanyRenewal from '@/pages/services/CompanyRenewal';
import IssueOfShares from '@/pages/services/IssueOfShares';
import NomineeDirector from '@/pages/services/NomineeDirector';
import TaxAdvisory from '@/pages/services/TaxAdvisory';
import TransferOfShares from '@/pages/services/TransferOfShares';
import CFOServices from '@/pages/services/CFOServices';

// ScrollToTop component
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/contact" element={<Contact />} />
          
          {/* Existing Service Routes */}
          <Route path="/services/trademark-registration" element={<TrademarkRegistration />} />
          <Route path="/services/copyright-registration" element={<CopyrightRegistration />} />
          <Route path="/services/company-formation" element={<CompanyFormation />} />
          <Route path="/services/trademark-search" element={<TrademarkSearch />} />
          <Route path="/services/amazon-brand-registry" element={<AmazonBrandRegistry />} />
          
          {/* Trademark Services */}
          <Route path="/services/register-trademark" element={<RegisterTrademark />} />
          <Route path="/services/clearance-search" element={<ClearanceSearch />} />
          <Route path="/services/trademark-transfers" element={<TrademarkTransfers />} />
          <Route path="/services/statements-of-use" element={<StatementsOfUse />} />
          <Route path="/services/trademark-office-actions" element={<TrademarkOfficeActions />} />
          <Route path="/services/trademark-monitoring" element={<TrademarkMonitoring />} />
          <Route path="/services/ttab-petition" element={<TTABPetition />} />
          
          {/* Company Formation Services */}
          <Route path="/services/llc-formation" element={<LLCFormation />} />
          <Route path="/services/c-corporation" element={<CCorporation />} />
          <Route path="/services/s-corporation" element={<SCorporation />} />
          <Route path="/services/non-profit" element={<NonProfit />} />
          
          {/* Copyright Services */}
          <Route path="/services/register-copyright" element={<RegisterCopyright />} />
          <Route path="/services/copyright-enforcement" element={<CopyrightEnforcement />} />
          <Route path="/services/copyright-transfers" element={<CopyrightTransfers />} />
          <Route path="/services/copyright-legal-representation" element={<CopyrightLegalRepresentation />} />
          <Route path="/services/copyright-portfolio" element={<CopyrightPortfolio />} />
          <Route path="/services/dmca-compliance" element={<DMCACompliance />} />
          
          {/* Patent Services */}
          <Route path="/services/patent-search" element={<PatentSearch />} />
          <Route path="/services/patent-office-actions" element={<PatentOfficeActions />} />
          <Route path="/services/patent-application" element={<PatentApplication />} />
          <Route path="/services/patent-legal-representation" element={<PatentLegalRepresentation />} />
          
          {/* Legal Services */}
          <Route path="/services/business-immigration" element={<BusinessImmigration />} />
          <Route path="/services/due-diligence" element={<DueDiligence />} />
          <Route path="/services/it-commercial-law" element={<ITCommercialLaw />} />
          <Route path="/services/partnerships-llp" element={<PartnershipsLLP />} />
          <Route path="/services/data-protection" element={<DataProtection />} />
          
          {/* Additional Corporate Services */}
          <Route path="/services/bookkeeping" element={<Bookkeeping />} />
          <Route path="/services/business-formation" element={<BusinessFormation />} />
          <Route path="/services/certificate-good-standing" element={<CertificateGoodStanding />} />
          <Route path="/services/company-dissolution" element={<CompanyDissolution />} />
          <Route path="/services/company-name-change" element={<CompanyNameChange />} />
          <Route path="/services/company-renewal" element={<CompanyRenewal />} />
          <Route path="/services/issue-of-shares" element={<IssueOfShares />} />
          <Route path="/services/nominee-director" element={<NomineeDirector />} />
          <Route path="/services/tax-advisory" element={<TaxAdvisory />} />
          <Route path="/services/transfer-of-shares" element={<TransferOfShares />} />
          <Route path="/services/cfo-services" element={<CFOServices />} />
          
          {/* Other Pages */}
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
          <Route path="/terms-of-service" element={<TermsOfService />} />
          <Route path="/lp" element={<LandingPage />} />
          <Route path="/landing" element={<LandingPage />} />
        </Routes>
        <Toaster position="top-right" />
      </BrowserRouter>
    </div>
  );
}

export default App;